import {
  // DeleteOutlined,
  // EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { Switch, TableColumnsType } from "antd";

import { ISalaryRange, ICountry, IVersion } from "@types";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import { dateFormat } from "@/constants";
import { GoPencil } from "react-icons/go";
import { BsTrash3 } from "react-icons/bs";
import { MutableRefObject } from "react";
import { MdOutlineFileDownload } from "react-icons/md";

export const getColumns = ({
  editSalaryRange,
  isDeleting,
  salary_range_id,
  removeSalaryRange,
}: {
  editSalaryRange: (salaryRange: ISalaryRange) => void;
  isDeleting: boolean;
  salary_range_id: React.MutableRefObject<any>;
  removeSalaryRange: (id: number) => Promise<void>;
}): TableColumnsType<any> => [
    {
      title: "grade",
      dataIndex: "grade",
      key: "grade",
      width: 200,
      sorter: true,
      align: "center",
    },
    {
      title: "country",
      dataIndex: "country",
      key: "country",
      width: 200,
      render: (country: ICountry) => country.name,
      sorter: true,
      align: "center",
    },
    {
      title: "city",
      dataIndex: "city",
      key: "city",
      width: 200,
      sorter: true,
      align: "center",
    },
    {
      title: "tier",
      dataIndex: "tier",
      key: "tier",
      width: 200,
      sorter: true,
      align: "center",
    },
    {
      title: "range name",
      dataIndex: "range_type",
      key: "range_type",
      width: 200,
      sorter: true,
      align: "center",
    },

    {
      title: "year",
      dataIndex: "year",
      key: "year",
      width: 200,
      sorter: true,
      align: "center",
    },
    {
      title: "min",
      dataIndex: "salary_min",
      key: "salary_min",
      width: 200,
      sorter: true,
      align: "center",
    },
    {
      title: "mid",
      dataIndex: "salary_mid",
      key: "salary_mid",
      width: 200,
      sorter: true,
      align: "center",
    },
    {
      title: "max",
      dataIndex: "salary_max",
      key: "salary_max",
      width: 200,
      sorter: true,
      align: "center",
    },
    ...(checkPermission([
      permissions.DELETE_SALARY_RANGE,
      permissions.UPDATE_SALARY_RANGE,
    ])
      ? ([
        {
          title: "Actions",
          key: "actions",
          width: 160,
          fixed: "right",
          align: "center",
          render: (salaryRange: ISalaryRange) => (
            <div className="flex items-center gap-2">
              {checkPermission(permissions.UPDATE_SALARY_RANGE) && (
                <div
                  onClick={() => editSalaryRange(salaryRange)}
                  className="table__action__btn table__action__btn--client"
                >
                  <GoPencil className="text-white mr-1 text-sm" /> Edit
                </div>
              )}
              {checkPermission(permissions.DELETE_SALARY_RANGE) && (
                <div
                  onClick={() => removeSalaryRange(salaryRange?.id!)}
                  className="table__action__btn table__action__btn--delete"
                >
                  {isDeleting &&
                    salaryRange?.id === salary_range_id?.current ? (
                    <LoadingOutlined color="#B62424" className="spinner" />
                  ) : (
                    <>
                      <BsTrash3 className="text-white textx mr-1" /> Delete
                    </>
                  )}
                </div>
              )}
            </div>
          ),
        },
      ] as any)
      : []),
  ];



export const getVersionsColumns = ({
  handleActive,
  versionId,
  download,
  isDownloading,
  downloadingVersionId,
}: {
  handleActive: (id: number) => Promise<void>;
  versionId: number | null;
  download: (id?: number) => Promise<void>;
  isDownloading: boolean;
  downloadingVersionId: MutableRefObject<number | null>;
}): TableColumnsType<any> => [
    {
      title: "created at",
      dataIndex: "created_at",
      key: "created_at",
      width: 240,
      align: "center",
      render: (date: string) => (
        <div>{moment(date).format(dateFormat)}</div>
      ),
    },
    {
      title: "updated at",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 240,
      align: "center",
      render: (date: string) => (
        <div>{moment(date).format(dateFormat)}</div>
      ),
    },

    ...(!checkPermission(permissions.CREATE_SALARY_RANGE)
      ? []
      : ([
        {
          title: "Active",
          key: "active",
          width: 140,
          align: "center",
          render: (version: IVersion) => (
            <Switch
              onChange={checked => {
                if (!checked) return;
                handleActive(version?.id);
              }}
              checked={versionId === version?.id}
              defaultChecked={version?.is_active === "TRUE"}
            />
          ),
        },
      ] as any)),

    // Takes all remaining width
    {
      title: "",
      key: "spacer",
    },

    {
      title: "Actions",
      key: "action",
      width: 180,
      align: "center",
      render: (version: IVersion) => (
        <div className="flex items-center justify-center">
          <div
            onClick={() => {
              if (!isDownloading) {
                download(version?.id);
              }
            }}
            className="table__action__btn table__action__btn--download"
          >
            {isDownloading &&
              downloadingVersionId.current === version?.id ? (
              <LoadingOutlined className="spinner" />
            ) : (
              <>
                <MdOutlineFileDownload className="text-white text-xl mr-1" />
                Download
              </>
            )}
          </div>
        </div>
      ),
    },
  ];
